import { useLocation } from "react-router-dom";
import { AuthActiveView } from '../entities';

export function useCurrentView(): AuthActiveView {
    const location = useLocation();
    return location.pathname?.match(/\/auth\/(.*)/)?.[1]?.split("/")[0] as AuthActiveView;
}